// extracted by mini-css-extract-plugin
export default {"overlay":"HB-z","bodyOpen":"IB-z","content":"JB-z","header":"KB-z","closeNoHeading":"LB-z"};